// src/app/store/asistencia/asistencia.actions.ts
import { Action } from '@ngrx/store';
import { AsistenciaDTO } from '@app/models/backend/asistencia';

export enum AsistenciaActionTypes {
  // Estados de actividades
  UPDATE_BREAK_STATUS = '[Asistencia] Update Break Status',
  UPDATE_BANO_STATUS = '[Asistencia] Update Bano Status',
  UPDATE_ASISTENCIA_DATA = '[Asistencia] Update Asistencia Data',
  UPDATE_ESTADO_COMPLETO = '[Asistencia] Update Estado Completo',

  // Acciones de actividades - CON SUCCESS/FAILURE
  INICIAR_BREAK = '[Asistencia] Iniciar Break',
  INICIAR_BREAK_SUCCESS = '[Asistencia] Iniciar Break Success',
  INICIAR_BREAK_FAILURE = '[Asistencia] Iniciar Break Failure',

  FINALIZAR_BREAK = '[Asistencia] Finalizar Break',
  FINALIZAR_BREAK_SUCCESS = '[Asistencia] Finalizar Break Success',
  FINALIZAR_BREAK_FAILURE = '[Asistencia] Finalizar Break Failure',

  INICIAR_BANO = '[Asistencia] Iniciar Bano',
  INICIAR_BANO_SUCCESS = '[Asistencia] Iniciar Bano Success',
  INICIAR_BANO_FAILURE = '[Asistencia] Iniciar Bano Failure',

  FINALIZAR_BANO = '[Asistencia] Finalizar Bano',
  FINALIZAR_BANO_SUCCESS = '[Asistencia] Finalizar Bano Success',
  FINALIZAR_BANO_FAILURE = '[Asistencia] Finalizar Bano Failure',

  // 🔥 NUEVO: Iniciar asistencia manual
  INICIAR_ASISTENCIA = '[Asistencia] Iniciar Asistencia',
  INICIAR_ASISTENCIA_SUCCESS = '[Asistencia] Iniciar Asistencia Success',
  INICIAR_ASISTENCIA_FAILURE = '[Asistencia] Iniciar Asistencia Failure',

  MARCAR_SALIDA = '[Asistencia] Marcar Salida',
  MARCAR_SALIDA_SUCCESS = '[Asistencia] Marcar Salida Success',
  MARCAR_SALIDA_FAILURE = '[Asistencia] Marcar Salida Failure',

  // Estados de carga
  SET_LOADING = '[Asistencia] Set Loading',
  SET_ERROR = '[Asistencia] Set Error',
  CLEAR_ERROR = '[Asistencia] Clear Error',

  // Datos del día (Legacy)
  LOAD_ASISTENCIAS_HOY = '[Asistencia] Load Asistencias Hoy',
  LOAD_ASISTENCIAS_HOY_SUCCESS = '[Asistencia] Load Asistencias Hoy Success',
  LOAD_ASISTENCIAS_HOY_FAILURE = '[Asistencia] Load Asistencias Hoy Failure',

  // Verificaciones automáticas
  VERIFICAR_ESTADO_ACTIVIDADES = '[Asistencia] Verificar Estado Actividades',
  VERIFICAR_ESTADO_ACTIVIDADES_SUCCESS = '[Asistencia] Verificar Estado Actividades Success',
  AUTO_FINALIZAR_ACTIVIDADES = '[Asistencia] Auto Finalizar Actividades',

  // Reset y sincronización (Legacy)
  RESET_ESTADO = '[Asistencia] Reset Estado',
  SINCRONIZAR_CON_SERVIDOR = '[Asistencia] Sincronizar Con Servidor',

  // Endpoint optimizado para asesor
  LOAD_ASISTENCIAS_ASESOR_OPTIMIZADO = '[Asistencia] Load Asistencias Asesor Optimizado',
  LOAD_ASISTENCIAS_ASESOR_OPTIMIZADO_SUCCESS = '[Asistencia] Load Asistencias Asesor Optimizado Success',
  LOAD_ASISTENCIAS_ASESOR_OPTIMIZADO_FAILURE = '[Asistencia] Load Asistencias Asesor Optimizado Failure',

  // Puntos de entrada para effects orquestadores
  HEADER_REFRESCAR_ESTADO = '[Asistencia Header] Refrescar Estado',
  HEADER_MENU_ABIERTO = '[Asistencia Header] Menu Abierto',
  ASESOR_PAGINA_CARGADA = '[Asistencia Asesor Page] Página Cargada',
}

// INTERFACES
export interface ActividadPayload {
  usuarioId: number;
  timestamp?: Date;
  observaciones?: string;
}

export interface EstadoActividadPayload {
  activo: boolean;
  duracion?: number;
  tiempoInicio?: Date;
  excedido?: boolean;
}

export interface AsistenciaEstadoCompleto {
  breakActivo: boolean;
  banoActivo: boolean;
  totalBreaks: number;
  totalBanos: number;
  puedeTomarBreak: boolean;
  puedeIrAlBano: boolean;
  horaSalida: string | null;
  // 🔥 CORREGIDO: Usar las claves que realmente envía el backend
  breakTiempoActual?: number;
  banoTiempoActual?: number;
  breakExcedido?: boolean;
  banoExcedido?: boolean;
  yaRegistroEntrada?: boolean; // 🔥 NUEVO: Si ya registró entrada hoy
  yaMarcoSalida?: boolean; // 🔥 NUEVO: Si ya marcó salida hoy
  // 🔥 NUEVO: Propiedades adicionales del backend
  estadoActual?: string;
  tiempoBreaksMinutos?: number;
  tiempoBanosMinutos?: number;
  tiempoNetoTrabajado?: number;
  porcentajeJornada?: number;
}

export interface AsistenciaState {
  breakActivo: boolean;
  banoActivo: boolean;
  totalBreaks: number;
  totalBanos: number;
  puedeTomarBreak: boolean;
  puedeIrAlBano: boolean;
  horaSalida: string | null;
  tiempoBreakActual: number;
  tiempoBanoActual: number;
  breakExcedido: boolean;
  banoExcedido: boolean;
  tiempoTrabajado: string;
  tiempoDescansos: string;
  porcentajeJornada: number;
  loading: boolean;
  loadingBreak: boolean;
  loadingBano: boolean;
  loadingSalida: boolean;
  loadingAsistencia: boolean; // 🔥 NUEVO: Loading para iniciar asistencia
  yaRegistroEntrada: boolean; // 🔥 NUEVO: Si ya registró entrada hoy
  yaMarcoSalida: boolean; // 🔥 NUEVO: Si ya marcó salida hoy
  error: string | null;
  asistenciasHoy: AsistenciaDTO[];
  asistenciasAsesorOptimizadas: any[];
  lastUpdated: Date | null;
  sincronizado: boolean;
  // 🔥 NUEVO: Tiempos en segundos para cálculos más precisos
  banoTiempoActualSegundos: number; // Tiempo en segundos del baño activo
  breakTiempoActualSegundos: number; // Tiempo en segundos del break activo
}

// CLASES DE ACCIONES
export class UpdateBreakStatus implements Action {
  readonly type = AsistenciaActionTypes.UPDATE_BREAK_STATUS;
  constructor(public payload: EstadoActividadPayload) {}
}
export class UpdateBanoStatus implements Action {
  readonly type = AsistenciaActionTypes.UPDATE_BANO_STATUS;
  constructor(public payload: EstadoActividadPayload) {}
}
export class UpdateAsistenciaData implements Action {
  readonly type = AsistenciaActionTypes.UPDATE_ASISTENCIA_DATA;
  constructor(public payload: Partial<AsistenciaState>) {}
}
export class UpdateEstadoCompleto implements Action {
  readonly type = AsistenciaActionTypes.UPDATE_ESTADO_COMPLETO;
  constructor(public payload: AsistenciaEstadoCompleto) {}
}
export class IniciarBreak implements Action {
  readonly type = AsistenciaActionTypes.INICIAR_BREAK;
  constructor(public payload: { usuarioId: number }) {}
}
export class IniciarBreakSuccess implements Action {
  readonly type = AsistenciaActionTypes.INICIAR_BREAK_SUCCESS;
  constructor(public payload: any) {}
}
export class IniciarBreakFailure implements Action {
  readonly type = AsistenciaActionTypes.INICIAR_BREAK_FAILURE;
  constructor(public payload: string) {}
}
export class FinalizarBreak implements Action {
  readonly type = AsistenciaActionTypes.FINALIZAR_BREAK;
  constructor(public payload: { usuarioId: number }) {}
}
export class FinalizarBreakSuccess implements Action {
  readonly type = AsistenciaActionTypes.FINALIZAR_BREAK_SUCCESS;
  constructor(public payload: any) {}
}
export class FinalizarBreakFailure implements Action {
  readonly type = AsistenciaActionTypes.FINALIZAR_BREAK_FAILURE;
  constructor(public payload: string) {}
}
export class IniciarBano implements Action {
  readonly type = AsistenciaActionTypes.INICIAR_BANO;
  constructor(public payload: { usuarioId: number }) {}
}
export class IniciarBanoSuccess implements Action {
  readonly type = AsistenciaActionTypes.INICIAR_BANO_SUCCESS;
  constructor(public payload: any) {}
}
export class IniciarBanoFailure implements Action {
  readonly type = AsistenciaActionTypes.INICIAR_BANO_FAILURE;
  constructor(public payload: string) {}
}
export class FinalizarBano implements Action {
  readonly type = AsistenciaActionTypes.FINALIZAR_BANO;
  constructor(public payload: { usuarioId: number }) {}
}
export class FinalizarBanoSuccess implements Action {
  readonly type = AsistenciaActionTypes.FINALIZAR_BANO_SUCCESS;
  constructor(public payload: any) {}
}
export class FinalizarBanoFailure implements Action {
  readonly type = AsistenciaActionTypes.FINALIZAR_BANO_FAILURE;
  constructor(public payload: string) {}
}

// 🔥 NUEVO: Acciones para Iniciar Asistencia
export class IniciarAsistencia implements Action {
  readonly type = AsistenciaActionTypes.INICIAR_ASISTENCIA;
  constructor(public payload: { usuarioId: number }) {}
}
export class IniciarAsistenciaSuccess implements Action {
  readonly type = AsistenciaActionTypes.INICIAR_ASISTENCIA_SUCCESS;
  constructor(public payload: any) {}
}
export class IniciarAsistenciaFailure implements Action {
  readonly type = AsistenciaActionTypes.INICIAR_ASISTENCIA_FAILURE;
  constructor(public payload: string) {}
}

export class MarcarSalida implements Action {
  readonly type = AsistenciaActionTypes.MARCAR_SALIDA;
  constructor(public payload: { usuarioId: number }) {}
}
export class MarcarSalidaSuccess implements Action {
  readonly type = AsistenciaActionTypes.MARCAR_SALIDA_SUCCESS;
  constructor(public payload: any) {}
}
export class MarcarSalidaFailure implements Action {
  readonly type = AsistenciaActionTypes.MARCAR_SALIDA_FAILURE;
  constructor(public payload: string) {}
}
export class SetLoading implements Action {
  readonly type = AsistenciaActionTypes.SET_LOADING;
  constructor(public payload: boolean) {}
}
export class SetError implements Action {
  readonly type = AsistenciaActionTypes.SET_ERROR;
  constructor(public payload: string | null) {}
}
export class ClearError implements Action {
  readonly type = AsistenciaActionTypes.CLEAR_ERROR;
}
export class LoadAsistenciasHoy implements Action {
  readonly type = AsistenciaActionTypes.LOAD_ASISTENCIAS_HOY;
  constructor(public payload: { usuarioId: number; fecha: string }) {}
}
export class LoadAsistenciasHoySuccess implements Action {
  readonly type = AsistenciaActionTypes.LOAD_ASISTENCIAS_HOY_SUCCESS;
  constructor(public payload: AsistenciaDTO[]) {}
}
export class LoadAsistenciasHoyFailure implements Action {
  readonly type = AsistenciaActionTypes.LOAD_ASISTENCIAS_HOY_FAILURE;
  constructor(public payload: string) {}
}
export class VerificarEstadoActividades implements Action {
  readonly type = AsistenciaActionTypes.VERIFICAR_ESTADO_ACTIVIDADES;
  constructor(public payload: { usuarioId: number }) {}
}
export class VerificarEstadoActividadesSuccess implements Action {
  readonly type = AsistenciaActionTypes.VERIFICAR_ESTADO_ACTIVIDADES_SUCCESS;
  constructor(public payload: AsistenciaEstadoCompleto) {}
}
export class AutoFinalizarActividades implements Action {
  readonly type = AsistenciaActionTypes.AUTO_FINALIZAR_ACTIVIDADES;
  constructor(public payload: { usuarioId: number; tipo: 'break' | 'bano' | 'ambos' }) {}
}
export class ResetEstado implements Action {
  readonly type = AsistenciaActionTypes.RESET_ESTADO;
}
export class SincronizarConServidor implements Action {
  readonly type = AsistenciaActionTypes.SINCRONIZAR_CON_SERVIDOR;
  constructor(public payload: { usuarioId: number }) {}
}
export class LoadAsistenciasAsesorOptimizado implements Action {
  readonly type = AsistenciaActionTypes.LOAD_ASISTENCIAS_ASESOR_OPTIMIZADO;
  constructor(public payload: { usuarioId: number; fechaInicio: string; fechaFin: string }) {}
}
export class LoadAsistenciasAsesorOptimizadoSuccess implements Action {
  readonly type = AsistenciaActionTypes.LOAD_ASISTENCIAS_ASESOR_OPTIMIZADO_SUCCESS;
  constructor(public payload: any[]) {}
}
export class LoadAsistenciasAsesorOptimizadoFailure implements Action {
  readonly type = AsistenciaActionTypes.LOAD_ASISTENCIAS_ASESOR_OPTIMIZADO_FAILURE;
  constructor(public payload: string) {}
}
export class HeaderRefrescarEstado implements Action {
  readonly type = AsistenciaActionTypes.HEADER_REFRESCAR_ESTADO;
}

export class HeaderMenuAbierto implements Action {
  readonly type = AsistenciaActionTypes.HEADER_MENU_ABIERTO;
}

export class AsesorPaginaCargada implements Action {
  readonly type = AsistenciaActionTypes.ASESOR_PAGINA_CARGADA;
}

// 🔥 UNION TYPE COMPLETO Y CORREGIDO
export type AsistenciaActions =
  | UpdateBreakStatus
  | UpdateBanoStatus
  | UpdateAsistenciaData
  | UpdateEstadoCompleto
  | IniciarBreak
  | IniciarBreakSuccess
  | IniciarBreakFailure
  | FinalizarBreak
  | FinalizarBreakSuccess
  | FinalizarBreakFailure
  | IniciarBano
  | IniciarBanoSuccess
  | IniciarBanoFailure
  | FinalizarBano
  | FinalizarBanoSuccess
  | FinalizarBanoFailure
  | IniciarAsistencia
  | IniciarAsistenciaSuccess
  | IniciarAsistenciaFailure
  | MarcarSalida
  | MarcarSalidaSuccess
  | MarcarSalidaFailure
  | SetLoading
  | SetError
  | ClearError
  | LoadAsistenciasHoy
  | LoadAsistenciasHoySuccess
  | LoadAsistenciasHoyFailure
  | VerificarEstadoActividades
  | VerificarEstadoActividadesSuccess
  | AutoFinalizarActividades
  | ResetEstado
  | SincronizarConServidor
  | LoadAsistenciasAsesorOptimizado
  | LoadAsistenciasAsesorOptimizadoSuccess
  | LoadAsistenciasAsesorOptimizadoFailure
  | HeaderRefrescarEstado
  | HeaderMenuAbierto
  | AsesorPaginaCargada;
